import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED = createFcmDetails(
	'supporter_to_starter_recommendations_enabled',
	{
		owner: 'starfish',
		context: 'Start a Recommended Petition Flow in PSF',
		description: 'Flag for the supporter to starter recommendations experience.',
		import: false,
		mergeLogic: 'Needs combination of both country code and locale to be enabled.',
	},
);
